<template>
    <div v-if="open">
        <pml-dropzone :link="`/deals/${deal.id}/attachments`" :max-file-size="5" :accepted-files="acceptedFiles" @upload="upload"></pml-dropzone>
        <hr>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'AttachmentsUpload',
        props: [ 'deal', 'open' ],
        data () {
            return {
                acceptedFiles: '.pdf, .png, .jpg, .jpeg, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .zip'
            }
        },
        methods: {
            ...mapActions([ 'saveAttachment' ]),
            upload (item) {
                this.saveAttachment(item)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/attachments/Upload.vue